var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var OFFER_GALLERY_TYPE = 'offer';
        var WISHLIST_GALLERY_TYPE = 'wishlist';
        var HOTEL_VIEW_TYPE = 'hotel-view';
        var INITIAL_LOAD_COUNT = 4; // Количество фото для первоначальной загрузки
        var BRAND_STATIC_DOMAIN = window.app.staticDomain;

        var HotelPhotoGallery = function () {
            function HotelPhotoGallery(params) {
                _classCallCheck(this, HotelPhotoGallery);

                this.hotelId = params.hotelId;
                this.galleryType = params.galleryType;
                this.hotelPhoto = params.hotelPhoto;
                this.hotelRooms = params.hotelRoomDetails || window.hotelRoomDetails || null;
                this.hotelTouristsPhoto = params.hotelTouristsPhoto || window.hotelTouristsPhoto || null;
                this.eventPage = params.eventPage;
                this.loadedSlides = new Set(); // Отслеживаем загруженные слайды
                this.fullscreenSwiper = null;
                this.loadedFullscreenSlides = new Set();
                this.categoryFilterAnimationTimer = null;
                this.modalPhotoObserver = null;
                this.modalPhotoScrollContainer = null;
                this.modalPhotoScrollHandler = null;
                this.modalPhotoLoaderFrame = null;
                this.modalPhotoLoaderRetryTimer = null;

                // Инициализируем первые слайды как загруженные
                for (var i = 0; i < Math.min(INITIAL_LOAD_COUNT, this.hotelPhoto.length || 0); i++) {
                    this.loadedSlides.add(i);
                }

                this.initHotelPhotoSwiper();
                this.handlers();
                this.hotelName = params.hotelName;
            }

            _createClass(HotelPhotoGallery, [{
                key: "renderModalContent",
                value: function renderModalContent() {
                    var _this = this;

                    var photos = this.hotelPhoto || [];
                    var photoCategoryFilterBlock = this.createPhotoCategoryFilterBlock();
                    var images = photos.map(function (photo, index) {
                        var categoryName = photo.category ? photo.category.name : '';
                        return _this.createModalPhotoItem({
                            imageClass: 'hotel-photo-on-modal',
                            imageUrl: BRAND_STATIC_DOMAIN + "/img/h/" + photo.url,
                            alt: 'hotel photo',
                            useDataSrc: true,
                            extraAttributes: "data-category=\"" + categoryName + "\" data-index=\"" + index + "\""
                        });
                    }).join('');

                    var roomsHtml = '';
                    if (this.hotelRooms) {
                        roomsHtml = '<div class="hotel-rooms-photos" style="display: none;">';

                        var roomIndex = 0;
                        // Для каждого типа комнаты
                        for (var roomName in this.hotelRooms) {
                            var roomPhotos = this.hotelRooms[roomName];
                            if (roomPhotos && roomPhotos.length > 0) {
                                roomsHtml += "<div class=\"room-photos-section\" data-index=\"" + roomIndex + "\">\n                        <div class=\"room-name\">" + roomName + "</div>\n                        <div class=\"room-photos-container\">";

                                for (var i = 0; i < roomPhotos.length; i++) {
                                    var photoUrl = roomPhotos[i];

                                    roomsHtml += this.createModalPhotoItem({
                                        imageClass: 'hotel-view__gallery-img room-photo',
                                        imageUrl: photoUrl,
                                        alt: roomName,
                                        useDataSrc: true,
                                        extraAttributes: "data-category=\"" + roomName + "\""
                                    });
                                }

                                roomsHtml += '</div></div>';
                            }

                            roomIndex++;
                        }

                        roomsHtml += '</div>';
                    }

                    var touristsPhotoHtml = '';
                    if (this.hotelTouristsPhoto && this.hotelTouristsPhoto.length > 0) {
                        touristsPhotoHtml += "<div class=\"tourists-photos-container\" style=\"display: none;\">";
                        this.hotelTouristsPhoto.forEach(function (photoUrl) {
                            touristsPhotoHtml += _this.createModalPhotoItem({
                                imageClass: 'hotel-view__gallery-img tourist-photo',
                                imageUrl: photoUrl,
                                alt: 'tourist photo',
                                useDataSrc: true,
                                extraAttributes: 'data-category="Фото туристов"'
                            });
                        });
                        touristsPhotoHtml += '</div>';
                    }

                    var contentHtml = "" + photoCategoryFilterBlock + touristsPhotoHtml + "<div class=\"hotel-general-photos\">" + images + "</div>" + roomsHtml;
                    window.modal.open({
                        content: {
                            html: contentHtml
                        },
                        header: {
                            title: this.hotelName || '',
                            theme: window.modal.themes.PRIMARY
                        },
                        footer: false,
                        type: window.modal.types.FULL,
                        parentCssClass: 'hotel-photo-gallery-modal',
                        onBeforeRemove: function onBeforeRemove() {
                            _this.cleanupModalPhotoLoaders();
                            _this.removeNextRoomButton();
                        },
                        onAfterShow: function onAfterShow() {
                            _this.initPhotoCategorySwiper();
                            _this.removeNextRoomButton();
                            _this.initModalPhotoLoaders();

                            setTimeout(function () {
                                var modalPhotos = document.querySelectorAll('.hotel-photo-gallery-modal .hotel-photo-on-modal');
                                modalPhotos.forEach(function (photo) {
                                    photo.addEventListener('click', function (event) {
                                        var index = parseInt(photo.dataset.index, 10) || 0;
                                        _this.openFullscreenPhotoViewer(index);

                                        // Send analytics event
                                        var eventProperties = { Page: _this.eventPage };
                                        window.brxTracking.sendAnalyticsEvent('click_photo_in_modal', eventProperties);

                                        event.stopPropagation();
                                    });
                                });
                            }, 300);
                        }
                    });
                }
            }, {
                key: "createPhotoCategoryFilterBlock",
                value: function createPhotoCategoryFilterBlock() {
                    // Создаем объект для хранения категорий и их первых изображений
                    var categoryImages = {}; // ключ — имя категории, значение — первое изображение
                    var categoryCounts = {};

                    // Находим первое изображение для каждой категории
                    this.hotelPhoto.forEach(function (photo) {
                        if (photo.category && photo.category.name) {
                            var category = photo.category.name;

                            if (!categoryImages[category]) {
                                categoryImages[category] = photo;
                            }

                            categoryCounts[category] = (categoryCounts[category] || 0) + 1;
                        }
                    });

                    // Проверяем, есть ли уже категория "Номер"
                    var hasRoomCategory = categoryImages.hasOwnProperty('Номер');

                    // Получаем последнее изображение для кнопки "Все фото"
                    var lastImage = this.hotelPhoto.length > 1 ? this.hotelPhoto[this.hotelPhoto.length - 2] : this.hotelPhoto[0];
                    var lastImageSrc = lastImage ? BRAND_STATIC_DOMAIN + "/img/h/sm/" + lastImage.url : '';

                    var categoryButtons = "\n    <div class=\"photo-category-filter-block\"> \n        <div id=\"photoCategorySwiper\" class=\"swiper\"> \n            <div class=\"swiper-wrapper\"> \n                <button class=\"swiper-slide photo-category active\" type=\"button\" data-category-id=\"*\"> \n                    <div style=\"display: flex; justify-content: center;\">\n                        <img src=\"" + lastImageSrc + "\" class=\"photo-category__img\" alt=\"\u0432\u0441\u0435 \u0444\u043E\u0442\u043E\">\n                    </div>\n                    <span class=\"bottom-line-span\">\u0412\u0441\u0435 \u0444\u043E\u0442\u043E</span>\n                </button>\n    ";

                    // Добавляем кнопки для каждой категории с изображениями
                    Object.keys(categoryImages).forEach(function (category) {
                        var photo = categoryImages[category];
                        var imgSrc = BRAND_STATIC_DOMAIN + "/img/h/sm/" + photo.url;
                        categoryButtons += "\n        <button class=\"swiper-slide photo-category\" type=\"button\" data-category-id=\"" + category + "\"> \n            <img src=\"" + imgSrc + "\" class=\"photo-category__img\" alt=\"" + category + "\">\n            <span class=\"bottom-line-span\">" + category + "</span>\n        </button>\n        ";
                    });

                    // Добавляем кнопку "Номер" только если её нет среди категорий
                    if (this.hotelRooms && !hasRoomCategory) {
                        var firstRoomName = Object.keys(this.hotelRooms)[0];
                        if (firstRoomName) {
                            var firstRoomPhotos = this.hotelRooms[firstRoomName];
                            if (firstRoomPhotos && firstRoomPhotos.length > 0) {
                                var roomImgSrc = firstRoomPhotos[0];

                                categoryButtons += "\n                <button class=\"swiper-slide photo-category\" type=\"button\" data-category-id=\"\u041D\u043E\u043C\u0435\u0440\"> \n                    <img src=\"" + roomImgSrc + "\" class=\"photo-category__img\" alt=\"\u041D\u043E\u043C\u0435\u0440\">\n                    <span class=\"bottom-line-span\">\u041D\u043E\u043C\u0435\u0440</span>\n                </button>\n                ";
                            }
                        }
                    }

                    // Добавляем кнопку "Фото туристов" если есть фотографии туристов
                    if (this.hotelTouristsPhoto && this.hotelTouristsPhoto.length > 0) {
                        var touristPhotoSrc = this.hotelTouristsPhoto[0];

                        categoryButtons += "\n            <button class=\"swiper-slide photo-category\" type=\"button\" data-category-id=\"\u0424\u043E\u0442\u043E \u0442\u0443\u0440\u0438\u0441\u0442\u043E\u0432\"> \n                <img src=\"" + touristPhotoSrc + "\" class=\"photo-category__img\" alt=\"\u0424\u043E\u0442\u043E \u0442\u0443\u0440\u0438\u0441\u0442\u043E\u0432\">\n                <span class=\"bottom-line-span\">\u0424\u043E\u0442\u043E \u0442\u0443\u0440\u0438\u0441\u0442\u043E\u0432</span>\n            </button>\n            ";
                    }

                    categoryButtons += "\n            </div> \n        </div> \n    </div>\n    ";

                    return categoryButtons;
                }
            }, {
                key: "createModalPhotoItem",
                value: function createModalPhotoItem(_ref) {
                    var imageClass = _ref.imageClass,
                        imageUrl = _ref.imageUrl,
                        alt = _ref.alt,
                        _ref$extraAttributes = _ref.extraAttributes,
                        extraAttributes = _ref$extraAttributes === undefined ? '' : _ref$extraAttributes,
                        _ref$useDataSrc = _ref.useDataSrc,
                        useDataSrc = _ref$useDataSrc === undefined ? false : _ref$useDataSrc;

                    var imageSourceAttribute = useDataSrc ? "data-src=\"" + imageUrl + "\"" : "src=\"" + imageUrl + "\"";

                    return "<div class=\"hotel-gallery-photo-item photo-item\">\n            <div class=\"photo-item-loader\"></div>\n            <img class=\"" + imageClass + "\" " + imageSourceAttribute + " alt=\"" + alt + "\" " + extraAttributes + ">\n        </div>";
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    if (this.galleryType !== WISHLIST_GALLERY_TYPE) {
                        var hotelPhotoSlides = document.querySelectorAll('#hotelPhotoSlider .hotel-photo-slide');

                        if (hotelPhotoSlides.length > 0) {
                            hotelPhotoSlides.forEach(function (slide) {
                                slide.addEventListener('click', function () {
                                    _this2.renderModalContent();
                                    var eventProperties = { Page: _this2.eventPage };
                                    window.brxTracking.sendAnalyticsEvent('click_hotel_photo_slider', eventProperties);
                                });
                            });
                        } else {
                            // Если элементы не найдены — пробуем через eventDispatcher
                            if (typeof eventDispatcher !== 'undefined') {
                                eventDispatcher.on('click', '#hotelPhotoSlider .hotel-photo-slide', function () {
                                    _this2.renderModalContent();
                                    var eventProperties = { Page: _this2.eventPage };
                                    window.brxTracking.sendAnalyticsEvent('click_hotel_photo_slider', eventProperties);
                                });
                            }
                        }
                    }
                }
            }, {
                key: "getModalScrollContainer",
                value: function getModalScrollContainer() {
                    return document.querySelector('.hotel-photo-gallery-modal.open .modal2-content') || document.querySelector('.hotel-photo-gallery-modal .modal2-content');
                }
            }, {
                key: "getModalRoot",
                value: function getModalRoot() {
                    return document.querySelector('.hotel-photo-gallery-modal.open') || document.querySelector('.hotel-photo-gallery-modal');
                }
            }, {
                key: "animateCategoryFilterItems",
                value: function animateCategoryFilterItems(items) {
                    var _this3 = this;

                    var visibleItems = (items || []).filter(Boolean);

                    if (!visibleItems.length) {
                        return;
                    }

                    if (this.categoryFilterAnimationTimer) {
                        window.clearTimeout(this.categoryFilterAnimationTimer);
                        this.categoryFilterAnimationTimer = null;
                    }

                    document.querySelectorAll('.is-gallery-category-filter-enter').forEach(function (item) {
                        item.classList.remove('is-gallery-category-filter-enter');
                    });

                    visibleItems.forEach(function (item, index) {
                        item.style.setProperty('--hotel-photo-category-order', String(Math.min(index, 4)));
                    });

                    void visibleItems[0].offsetWidth;

                    visibleItems.forEach(function (item) {
                        item.classList.add('is-gallery-category-filter-enter');
                    });

                    this.categoryFilterAnimationTimer = window.setTimeout(function () {
                        visibleItems.forEach(function (item) {
                            item.classList.remove('is-gallery-category-filter-enter');
                        });

                        _this3.categoryFilterAnimationTimer = null;
                    }, 500);
                }
            }, {
                key: "cleanupModalPhotoLoaders",
                value: function cleanupModalPhotoLoaders() {
                    if (this.modalPhotoObserver) {
                        this.modalPhotoObserver.disconnect();
                        this.modalPhotoObserver = null;
                    }

                    if (this.modalPhotoScrollContainer && this.modalPhotoScrollHandler) {
                        this.modalPhotoScrollContainer.removeEventListener('scroll', this.modalPhotoScrollHandler);
                    }

                    if (this.modalPhotoLoaderFrame) {
                        window.cancelAnimationFrame(this.modalPhotoLoaderFrame);
                        this.modalPhotoLoaderFrame = null;
                    }

                    if (this.modalPhotoLoaderRetryTimer) {
                        window.clearTimeout(this.modalPhotoLoaderRetryTimer);
                        this.modalPhotoLoaderRetryTimer = null;
                    }

                    this.modalPhotoScrollContainer = null;
                    this.modalPhotoScrollHandler = null;
                }
            }, {
                key: "getModalGalleryImages",
                value: function getModalGalleryImages() {
                    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                    return Array.from(container.querySelectorAll('.hotel-photo-gallery-modal .hotel-photo-on-modal, ' + '.hotel-photo-gallery-modal .room-photo, ' + '.hotel-photo-gallery-modal .tourist-photo'));
                }
            }, {
                key: "loadVisibleModalPhotos",
                value: function loadVisibleModalPhotos() {
                    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                    var scrollContainer = this.getModalScrollContainer();

                    if (!scrollContainer) {
                        return false;
                    }

                    var containerRect = scrollContainer.getBoundingClientRect();
                    var preloadOffset = 200;

                    this.getModalGalleryImages(container).forEach(function (image) {
                        if (!image.dataset.src || image.getAttribute('src') || image.offsetParent === null) {
                            return;
                        }

                        var rect = image.getBoundingClientRect();
                        var isVisible = rect.bottom >= containerRect.top - preloadOffset && rect.top <= containerRect.bottom + preloadOffset;

                        if (isVisible) {
                            image.src = image.dataset.src;
                        }
                    });

                    return true;
                }
            }, {
                key: "scheduleVisibleModalPhotosLoad",
                value: function scheduleVisibleModalPhotosLoad() {
                    var _this4 = this;

                    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                    if (this.modalPhotoLoaderFrame) {
                        return;
                    }

                    this.modalPhotoLoaderFrame = window.requestAnimationFrame(function () {
                        _this4.modalPhotoLoaderFrame = null;
                        _this4.loadVisibleModalPhotos(container);
                    });
                }
            }, {
                key: "initModalPhotoLoaders",
                value: function initModalPhotoLoaders() {
                    var _this5 = this;

                    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                    this.cleanupModalPhotoLoaders();

                    var scrollContainer = this.getModalScrollContainer();
                    var handleImageLoad = function handleImageLoad(image) {
                        var photoItem = image.closest('.photo-item');
                        var loader = photoItem ? photoItem.querySelector('.photo-item-loader') : null;

                        var hideLoader = function hideLoader() {
                            if (photoItem) {
                                photoItem.classList.add('loaded');
                            }
                            if (loader) {
                                loader.style.display = 'none';
                            }
                        };

                        if (image.complete && image.naturalWidth > 0) {
                            hideLoader();
                            return;
                        }

                        if (image.dataset.galleryLoaderBound === '1') {
                            return;
                        }

                        image.dataset.galleryLoaderBound = '1';
                        image.addEventListener('load', hideLoader);
                        image.addEventListener('error', hideLoader);
                    };

                    var images = this.getModalGalleryImages(container);

                    images.forEach(handleImageLoad);

                    if (!scrollContainer) {
                        this.modalPhotoLoaderRetryTimer = window.setTimeout(function () {
                            _this5.modalPhotoLoaderRetryTimer = null;
                            _this5.initModalPhotoLoaders(container);
                        }, 50);
                        return;
                    }

                    this.modalPhotoScrollContainer = scrollContainer;
                    this.modalPhotoScrollHandler = function () {
                        _this5.scheduleVisibleModalPhotosLoad(container);
                    };

                    scrollContainer.addEventListener('scroll', this.modalPhotoScrollHandler, { passive: true });

                    this.scheduleVisibleModalPhotosLoad(container);
                }
            }, {
                key: "removeNextRoomButton",
                value: function removeNextRoomButton() {
                    var nextRoomButton = document.getElementById('scroll-next-room');
                    if (nextRoomButton) {
                        nextRoomButton.remove();
                    }
                }
            }, {
                key: "renderNextRoomButton",
                value: function renderNextRoomButton() {
                    this.removeNextRoomButton();

                    var modalRoot = this.getModalRoot();
                    var sections = Array.from(document.querySelectorAll('.room-photos-section'));

                    if (!modalRoot || sections.length <= 1) {
                        return null;
                    }

                    var nextRoomButton = document.createElement('button');
                    nextRoomButton.type = 'button';
                    nextRoomButton.id = 'scroll-next-room';
                    nextRoomButton.className = 'hotel-photo-gallery-modal__next-room';
                    nextRoomButton.textContent = 'Следующий номер';

                    modalRoot.appendChild(nextRoomButton);

                    return nextRoomButton;
                }
            }, {
                key: "initNextRoomButton",
                value: function initNextRoomButton(nextRoomButton) {
                    var _this6 = this;

                    if (!nextRoomButton) return;

                    var sections = Array.from(document.querySelectorAll('.room-photos-section'));
                    var currentIndex = 0;

                    nextRoomButton.addEventListener('click', function () {
                        if (currentIndex < sections.length - 1) {
                            currentIndex++;
                            var nextSection = sections[currentIndex];
                            var container = _this6.getModalScrollContainer();

                            if (container && nextSection) {
                                var offsetTop = nextSection.offsetTop - 20; // Чуть-чуть смещение сверху
                                scrollToSmoothly(offsetTop, 400, container);
                            }

                            // Отправка аналитики
                            var hotelId = _this6.hotelId || '';
                            var eventProperties = {
                                HotelId: hotelId,
                                Page: _this6.eventPage
                            };
                            window.brxTracking.sendAnalyticsEvent('click_next_room_images', eventProperties);
                        }
                    });

                    function scrollToSmoothly(position, duration, element) {
                        var startPosition = element.scrollTop;
                        var distance = position - startPosition;
                        var startTime = null;

                        function animation(currentTime) {
                            if (startTime === null) startTime = currentTime;
                            var timeElapsed = currentTime - startTime;
                            var run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
                            element.scrollTop = run;
                            if (timeElapsed < duration) requestAnimationFrame(animation);
                        }

                        function easeInOutQuad(t, b, c, d) {
                            t /= d / 2;
                            if (t < 1) return c / 2 * t * t + b;
                            t--;
                            return -c / 2 * (t * (t - 2) - 1) + b;
                        }

                        requestAnimationFrame(animation);
                    }
                }
            }, {
                key: "loadSlideImage",
                value: function loadSlideImage(index) {
                    if (!this.swiper || !this.swiper.slides || this.loadedSlides.has(index)) return;
                    if (index < 0 || index >= this.swiper.slides.length) return;

                    var slideElement = this.swiper.slides[index];
                    if (!slideElement) return;

                    var lazyImage = slideElement.querySelector('img[data-src]');
                    if (lazyImage) {
                        // Загружаем изображение
                        lazyImage.src = lazyImage.dataset.src;
                        // Удаляем атрибут data-src после загрузки
                        lazyImage.removeAttribute('data-src');
                        // Отмечаем слайд как загруженный
                        this.loadedSlides.add(index);

                        // Убираем прелоадер после загрузки
                        lazyImage.onload = function () {
                            var preloader = slideElement.querySelector('.swiper-lazy-preloader');
                            if (preloader) {
                                preloader.style.display = 'none';
                            }
                        };
                    }
                }
            }, {
                key: "initHotelPhotoSwiper",
                value: function initHotelPhotoSwiper() {
                    var _this7 = this;

                    var params = {
                        preloadImages: false,
                        lazy: true,
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                        speed: 200,
                        // Ключевые параметры для одного слайда за свайп
                        slidesPerGroup: 1, // Переключать по одному слайду
                        // Настройки свайпа
                        touchRatio: 1,
                        touchAngle: 45,
                        threshold: 5, // Минимальное расстояние для начала свайпа
                        longSwipes: false, // Отключаем длинные свайпы
                        shortSwipes: true, // Включаем короткие свайпы
                        followFinger: true,
                        // Предотвращение множественных переключений
                        preventInteractionOnTransition: true,
                        allowTouchMove: true,
                        pagination: {
                            el: ".swiper-pagination",
                            dynamicBullets: true
                        },
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        },
                        on: {
                            slideChange: function slideChange(swiper) {
                                // Загружаем текущий слайд, предыдущий и следующий
                                var currentIndex = swiper.activeIndex;
                                _this7.loadSlideImage(currentIndex);
                                _this7.loadSlideImage(currentIndex - 1);
                                _this7.loadSlideImage(currentIndex + 1);
                                _this7.loadSlideImage(currentIndex + 2); // Предзагрузка на один вперед

                                // Управление видео в первом слайде
                                if (window.videoFirstSlideControls) {
                                    if (currentIndex === 0) {
                                        // Если вернулись к первому слайду, возобновляем воспроизведение
                                        window.videoFirstSlideControls.play();
                                    } else {
                                        // Если ушли с первого слайда, ставим видео на паузу
                                        window.videoFirstSlideControls.pause();
                                    }
                                }
                            },
                            init: function init(swiper) {
                                // Загружаем первые INITIAL_LOAD_COUNT изображений при инициализации
                                for (var i = 0; i < Math.min(INITIAL_LOAD_COUNT, swiper.slides.length); i++) {
                                    _this7.loadSlideImage(i);
                                }
                            }
                        }
                    };

                    this.swiper = new Swiper('#hotelPhotoSlider', params);
                }
            }, {
                key: "createFullscreenSlide",
                value: function createFullscreenSlide(_ref2) {
                    var imageUrl = _ref2.imageUrl,
                        alt = _ref2.alt;

                    return "<div class=\"swiper-slide\">\n            <div class=\"swiper-zoom-container\">\n                <img data-src=\"" + imageUrl + "\" alt=\"" + alt + "\">\n                <div class=\"swiper-lazy-preloader\"></div>\n            </div>\n        </div>";
                }
            }, {
                key: "createFullscreenGalleryHtml",
                value: function createFullscreenGalleryHtml(photos) {
                    var _this8 = this;

                    var slidesHtml = photos.map(function (photo) {
                        return _this8.createFullscreenSlide({
                            imageUrl: photo.src,
                            alt: photo.alt
                        });
                    }).join('');

                    return "<div class=\"hotel-photo-fullscreen\">\n            <div id=\"fullscreenPhotoSwiper\" class=\"swiper\">\n                <div class=\"swiper-wrapper\">" + slidesHtml + "</div>\n                <div class=\"swiper-pagination\"></div>\n                <div class=\"swiper-button-prev\"></div>\n                <div class=\"swiper-button-next\"></div>\n            </div>\n        </div>";
                }
            }, {
                key: "getFullscreenPhotosFromElements",
                value: function getFullscreenPhotosFromElements(photoElements, fallbackAlt) {
                    return Array.from(photoElements).map(function (photo) {
                        return {
                            src: photo.currentSrc || photo.getAttribute('src') || photo.dataset.src || '',
                            alt: photo.alt || fallbackAlt
                        };
                    }).filter(function (photo) {
                        return photo.src;
                    });
                }
            }, {
                key: "loadFullscreenSlideImage",
                value: function loadFullscreenSlideImage(index) {
                    if (!this.fullscreenSwiper || !this.fullscreenSwiper.slides || this.loadedFullscreenSlides.has(index)) return;
                    if (index < 0 || index >= this.fullscreenSwiper.slides.length) return;

                    var slideElement = this.fullscreenSwiper.slides[index];
                    if (!slideElement) return;

                    var lazyImage = slideElement.querySelector('img[data-src]');
                    if (lazyImage) {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.removeAttribute('data-src');
                        this.loadedFullscreenSlides.add(index);

                        var hidePreloader = function hidePreloader() {
                            var preloader = slideElement.querySelector('.swiper-lazy-preloader');
                            if (preloader) {
                                preloader.style.display = 'none';
                            }
                        };

                        lazyImage.onload = hidePreloader;
                        lazyImage.onerror = hidePreloader;
                    }
                }
            }, {
                key: "initFullscreenPhotoSwiper",
                value: function initFullscreenPhotoSwiper() {
                    var _this9 = this;

                    var initialSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

                    if (this.fullscreenSwiper) {
                        this.fullscreenSwiper.destroy();
                    }

                    this.loadedFullscreenSlides.clear();

                    this.fullscreenSwiper = new Swiper('#fullscreenPhotoSwiper', {
                        initialSlide: initialSlide,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        loop: false,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'fraction'
                        },
                        zoom: {
                            maxRatio: 3,
                            minRatio: 1
                        },
                        on: {
                            slideChange: function slideChange(swiper) {
                                var currentIndex = swiper.activeIndex;

                                _this9.loadFullscreenSlideImage(currentIndex);
                                _this9.loadFullscreenSlideImage(currentIndex - 1);
                                _this9.loadFullscreenSlideImage(currentIndex + 1);
                                _this9.loadFullscreenSlideImage(currentIndex + 2);
                            },
                            init: function init(swiper) {
                                var currentIndex = swiper.activeIndex;

                                _this9.loadFullscreenSlideImage(currentIndex);
                                _this9.loadFullscreenSlideImage(currentIndex - 1);
                                _this9.loadFullscreenSlideImage(currentIndex + 1);
                                _this9.loadFullscreenSlideImage(currentIndex + 2);
                            }
                        }
                    });

                    this.loadFullscreenSlideImage(initialSlide);
                    this.loadFullscreenSlideImage(initialSlide - 1);
                    this.loadFullscreenSlideImage(initialSlide + 1);
                    this.loadFullscreenSlideImage(initialSlide + 2);
                }
            }, {
                key: "openFullscreenGallery",
                value: function openFullscreenGallery(photos, initialSlide, openEventName) {
                    var _this10 = this;

                    if (!photos.length) {
                        return;
                    }

                    var safeInitialSlide = Math.max(0, Math.min(initialSlide, photos.length - 1));

                    window.modal.open({
                        content: {
                            html: this.createFullscreenGalleryHtml(photos),
                            theme: window.modal.themes.TRANSPARENT
                        },
                        header: {
                            theme: window.modal.themes.TRANSPARENT
                        },
                        footer: false,
                        type: window.modal.types.FULL,
                        parentCssClass: 'hotel-photo-fullscreen-modal',
                        onAfterShow: function onAfterShow() {
                            _this10.initFullscreenPhotoSwiper(safeInitialSlide);
                        },
                        onBeforeClose: function onBeforeClose() {
                            var eventProperties = { Page: _this10.eventPage };
                            window.brxTracking.sendAnalyticsEvent('close_fullscreen_photo', eventProperties);
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            if (_this10.fullscreenSwiper) {
                                _this10.fullscreenSwiper.destroy();
                                _this10.fullscreenSwiper = null;
                            }

                            _this10.loadedFullscreenSlides.clear();
                        }
                    });

                    var eventProperties = { Page: this.eventPage };
                    window.brxTracking.sendAnalyticsEvent(openEventName, eventProperties);
                }
            }, {
                key: "openFullscreenPhotoViewer",
                value: function openFullscreenPhotoViewer(index) {
                    var photos = (this.hotelPhoto || []).map(function (photo) {
                        return {
                            src: BRAND_STATIC_DOMAIN + "/img/h/" + photo.url,
                            alt: 'hotel photo'
                        };
                    });

                    this.openFullscreenGallery(photos, index, 'open_fullscreen_photo');
                }
            }, {
                key: "closeFullscreenPhotoViewer",
                value: function closeFullscreenPhotoViewer() {
                    window.modal.close('.hotel-photo-fullscreen-modal');
                }
            }, {
                key: "addRoomPhotosToFullscreenViewer",
                value: function addRoomPhotosToFullscreenViewer() {
                    var _this11 = this;

                    // Get all room photos
                    var roomPhotos = document.querySelectorAll('.room-photo');
                    if (!roomPhotos.length) return;

                    // Add event listeners to room photos
                    roomPhotos.forEach(function (photo) {
                        if (photo.dataset.roomFullscreenBound === '1') {
                            return;
                        }

                        photo.dataset.roomFullscreenBound = '1';
                        photo.addEventListener('click', function (event) {
                            // Create a temporary array of all visible room photos
                            var visibleRoomPhotos = Array.from(document.querySelectorAll('.room-photo:not([style*="display: none"])'));
                            var clickedIndex = visibleRoomPhotos.indexOf(photo);

                            // Create or update fullscreen viewer with room photos
                            _this11.updateFullscreenViewerWithRoomPhotos(visibleRoomPhotos, clickedIndex);

                            // Send analytics event
                            var eventProperties = { Page: _this11.eventPage };
                            window.brxTracking.sendAnalyticsEvent('click_room_photo_in_modal', eventProperties);

                            event.stopPropagation();
                        });
                    });
                }
            }, {
                key: "updateFullscreenViewerWithRoomPhotos",
                value: function updateFullscreenViewerWithRoomPhotos(roomPhotos, clickedIndex) {
                    var photos = this.getFullscreenPhotosFromElements(roomPhotos, 'room photo');
                    this.openFullscreenGallery(photos, clickedIndex, 'open_fullscreen_room_photo');
                }
            }, {
                key: "addTouristPhotosToFullscreenViewer",
                value: function addTouristPhotosToFullscreenViewer() {
                    var _this12 = this;

                    var touristPhotos = document.querySelectorAll('.tourist-photo');
                    if (!touristPhotos.length) return;

                    touristPhotos.forEach(function (photo) {
                        if (photo.dataset.touristFullscreenBound === '1') {
                            return;
                        }

                        photo.dataset.touristFullscreenBound = '1';
                        photo.addEventListener('click', function (event) {
                            var visibleTouristPhotos = Array.from(document.querySelectorAll('.tourist-photo:not([style*="display: none"])'));
                            var clickedIndex = visibleTouristPhotos.indexOf(photo);

                            _this12.updateFullscreenViewerWithTouristPhotos(visibleTouristPhotos, clickedIndex);

                            var eventProperties = { Page: _this12.eventPage };
                            window.brxTracking.sendAnalyticsEvent('click_tourist_photo_in_modal', eventProperties);

                            event.stopPropagation();
                        });
                    });
                }
            }, {
                key: "updateFullscreenViewerWithTouristPhotos",
                value: function updateFullscreenViewerWithTouristPhotos(touristPhotos, clickedIndex) {
                    var photos = this.getFullscreenPhotosFromElements(touristPhotos, 'tourist photo');
                    this.openFullscreenGallery(photos, clickedIndex, 'open_fullscreen_tourist_photo');
                }
            }, {
                key: "initPhotoCategorySwiper",
                value: function initPhotoCategorySwiper() {
                    var _this13 = this;

                    new Swiper('#photoCategorySwiper', {
                        freeMode: true,
                        freeModeMomentum: true,
                        loop: false,
                        slidesPerView: 4.3,
                        spaceBetween: 5,
                        speed: 500,
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        }
                    });

                    var photoCategories = document.querySelectorAll('.photo-category');
                    photoCategories.forEach(function (button) {
                        button.addEventListener('click', function (event) {
                            var selectedCategoryId = button.dataset.categoryId;
                            photoCategories.forEach(function (btn) {
                                return btn.classList.remove('active');
                            });
                            button.classList.add('active');

                            var generalPhotos = document.querySelector('.hotel-general-photos');
                            var hotelRoomss = document.querySelector('.hotel-rooms-photos');
                            var images = document.querySelectorAll('.hotel-photo-on-modal');
                            var generalPhotoItems = Array.from(images).map(function (img) {
                                return img.closest('.photo-item');
                            }).filter(Boolean);

                            // Прокручиваем контент к началу
                            var content = _this13.getModalScrollContainer();
                            if (content) {
                                content.scrollTop = 0;
                            }

                            var eventProperties = { Page: _this13.eventPage };
                            window.brxTracking.sendAnalyticsEvent('click_category_hotel_gallery', eventProperties);

                            if (selectedCategoryId === '*') {
                                _this13.removeNextRoomButton();

                                // Показываем все общие фото
                                if (generalPhotos) generalPhotos.style.display = 'grid';
                                if (hotelRoomss) hotelRoomss.style.display = 'none';

                                // Скрываем контейнер с фото туристов
                                var touristsPhotos = document.querySelector('.tourists-photos-container');
                                if (touristsPhotos) touristsPhotos.style.display = 'none';

                                generalPhotoItems.forEach(function (photoItem) {
                                    photoItem.style.display = 'flex';
                                });

                                _this13.initModalPhotoLoaders();
                                _this13.animateCategoryFilterItems(generalPhotoItems);
                            } else if (selectedCategoryId === 'Номер') {
                                // Показываем только фото номеров
                                if (generalPhotos) generalPhotos.style.display = 'none';
                                if (hotelRoomss) hotelRoomss.style.display = 'grid';

                                // Скрываем контейнер с фото туристов
                                var _touristsPhotos = document.querySelector('.tourists-photos-container');
                                if (_touristsPhotos) _touristsPhotos.style.display = 'none';

                                var roomSections = document.querySelectorAll('.room-photos-section');
                                _this13.initModalPhotoLoaders();

                                var nextRoomButton = _this13.renderNextRoomButton();
                                _this13.initNextRoomButton(nextRoomButton);
                                _this13.animateCategoryFilterItems(Array.from(roomSections));

                                // Add event listeners to room photos for fullscreen view
                                setTimeout(function () {
                                    _this13.addRoomPhotosToFullscreenViewer();
                                }, 300); // Small timeout to ensure photos are fully rendered
                            } else if (selectedCategoryId === 'Фото туристов') {
                                _this13.removeNextRoomButton();

                                // Показываем только фото туристов
                                if (generalPhotos) generalPhotos.style.display = 'none';
                                if (hotelRoomss) hotelRoomss.style.display = 'none';

                                // Показываем контейнер с фото туристов
                                var _touristsPhotos2 = document.querySelector('.tourists-photos-container');
                                if (_touristsPhotos2) _touristsPhotos2.style.display = 'grid';

                                _this13.initModalPhotoLoaders();

                                _this13.animateCategoryFilterItems(Array.from(document.querySelectorAll('.tourist-photo')).map(function (img) {
                                    return img.closest('.photo-item');
                                }).filter(Boolean));

                                // Add event listeners to tourist photos for fullscreen view
                                setTimeout(function () {
                                    _this13.addTouristPhotosToFullscreenViewer();
                                }, 300); // Small timeout to ensure photos are fully rendered
                            } else {
                                _this13.removeNextRoomButton();

                                // Показываем фото выбранной категории
                                if (generalPhotos) generalPhotos.style.display = 'grid';
                                if (hotelRoomss) hotelRoomss.style.display = 'none';

                                // Скрываем контейнер с фото туристов
                                var _touristsPhotos3 = document.querySelector('.tourists-photos-container');
                                if (_touristsPhotos3) _touristsPhotos3.style.display = 'none';

                                images.forEach(function (img) {
                                    var photoItem = img.closest('.photo-item');
                                    if (!photoItem) {
                                        return;
                                    }

                                    if (img.dataset.category === selectedCategoryId) {
                                        photoItem.style.display = 'flex';
                                    } else {
                                        photoItem.style.display = 'none';
                                    }
                                });

                                var categoryImages = Array.from(images).filter(function (img) {
                                    return img.dataset.category === selectedCategoryId;
                                });
                                _this13.initModalPhotoLoaders();

                                _this13.animateCategoryFilterItems(categoryImages.map(function (img) {
                                    return img.closest('.photo-item');
                                }).filter(Boolean));
                            }
                        });
                    });
                }
            }]);

            return HotelPhotoGallery;
        }();

        window.HotelPhotoGallery = HotelPhotoGallery;
    }, {}] }, {}, [1]);